import { render } from "./FieldSeparator.vue?vue&type=template&id=2d8c45ac"
import script from "./FieldSeparator.vue?vue&type=script&lang=js"
export * from "./FieldSeparator.vue?vue&type=script&lang=js"

import exportComponent from "/home/alexey/mv/mortgageware/vendor/sudoux/cms/Sudoux/Cms/FormBundle/Resources/views/Vuejs/Apps/formbuilder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
